<template src="./related-questions-list.html"></template>

<script lang="ts">
import { nextTick } from 'vue'
import domUtils from 'util/dom-utils'
import globalConfig from 'init/global.config'
import globalStore, { Store } from 'init/global-store'
import logger from 'util/logger'
import BasicQuestion from 'components/question/BasicQuestion.vue'
import PaginateMixin from 'mixins/PaginateMixin.vue'
import qaConfig from 'widgets/qa/qa.config'
import Question from 'components/question/Question.vue'
import relatedQuestionsService from 'services/api/related-questions-list'
import { RestError } from 'services/api-service'


export default {
  data() {
    return {
      relatedQuestions: [],
      globalStoreState: globalStore.state,
      showMoreDisabled: false
    }
  },
  components: {
    'tt-basic-question': BasicQuestion,
    'tt-question': Question
  },
  props: {
    showFullQuestion: {
      type: Boolean,
      default: true
    },
    widgetIsInitiallyHidden: {
      type: Boolean,
      default: false
    }
  },
  mixins: [PaginateMixin],
  computed: {
    currentSku(): string {
      return (this.globalStoreState as Store).sku
    },
    qaConfig() {
      return qaConfig
    },
    showBasicQuestions() {
      return qaConfig.enableLazyLoading && this.widgetIsInitiallyHidden &&
        !this.showFullQuestion
    },
    useShowMore() {
      return qaConfig.useShowMore
    }
  },
  methods: {
    fetchData(isPageChange) {
      if (this.currentSku && (this.offset === 0 || this.offset <= this.total)) {
        const limit = this.offset === 0 ? qaConfig.relatedInitialPageSize : qaConfig.relatedPageSize
        if (qaConfig.useShowMore && this.offset !== 0) {
          this.showMoreDisabled = true
        }
        relatedQuestionsService.relatedQuestionsList({
          sku: this.currentSku,
          offset: this.offset,
          limit,
          sort: qaConfig.defaultSortOption
        }).then((data) => {
          if (qaConfig.useShowMore && this.offset !== 0) {
            this.relatedQuestions.push(...data.relatedQuestions)
            this.showMoreDisabled = false
          } else {
            this.relatedQuestions = data.relatedQuestions
          }
          this.total = data.total
          if (isPageChange) {
            // not first time, so most likely paginated.  Will only scroll up, not down
            nextTick(() => {
              // TT-11837 - focus header after scroll. safeFocus in case client hides the header
              const focusFn = () => domUtils.safeFocus(() => this.$refs.heading)
              domUtils
                .scrollUpToRef(this.$refs, 'relQList', globalConfig.additionalPagingScroll)
                .then(focusFn)
                .catch(focusFn)
            })
          }
        }).catch((e: RestError) => {
          if (e.errorCode === 'turnto-offline') {
            logger.info('TurnTo is in offline mode - related questions not loaded', e)
          } else {
            logger.info('Error loading related question data for the Q&A widget', e)
          }
        })
      }
    }
  },
  created() {
    // initialPageSize and pageSize are in PaginateMixin
    this.initialPageSize = qaConfig.relatedInitialPageSize
    this.pageSize = qaConfig.relatedPageSize
    this.fetchData()
  },
  watch: {
    currentSku() {
      // onQueryChange method in PaginateMixin
      this.onQueryChange()
    }
  }
}
</script>

<style lang="scss" src="./related-questions-list.scss"></style>
